// extracted by mini-css-extract-plugin
export default {"logo":"Style_logo__H2ere"};